import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as StoreActions from 'x/modules/store/StoreState'
import XContainer from 'xui/components/XContainer'
import XCustomHeader from 'xui/components/XCustomHeader'
import XContent from 'xui/components/XContent'
import HStack from 'xui/components/HStack'
import Box from 'xui/components/Box'
import NB from 'x/config/nativebase'
import { getSelectedStore, getEditingStore } from 'x/redux/selectors'

import p from 'x/config/platform-specific'
import XCard from 'xui/components/XCard'
import XSettingRow from 'xui/components/XSettingRow'
import { ActionApiParams, ISelectedStoreMap, IXScreenProps } from 'x/types'
import * as util from 'x/utils/util'

interface IStoreSettingOrderAutomationProps extends IXScreenProps {
  selectedStore: ISelectedStoreMap
  submitEditing: ActionApiParams
  // addNewStoreSetting: (newSetting: any) => void
}

const StoreSettingOrderAutomation: React.FC<IStoreSettingOrderAutomationProps> = (props) => {
  const { submitEditing, selectedStore } = props
  // const [visibleShippingTypes, setVisibleShippingTypes] = useState<number[]>([])

  // eslint-disable-next-line react/no-unstable-nested-components
  const _renderHeader = () => (
    <XCustomHeader
      title={p.op.t('StoreSetting.MenuOrderAutomation')}
      headerLeftProps={{ backIcon: true, onPressItem: () => util.navGoBack(props) }}
    />
  )

  const _onSubmit = async (valueInt: number, stateKey: string) => {
    const store_id = selectedStore.get('id')
    const response = await new Promise((resolve) => {
      // @ts-ignore
      submitEditing({
        body: { store_id, [stateKey]: valueInt },
        successCallback: resolve,
        failedCallback: () => resolve(null),
      })
    })
    // console.log('response => ', response)
  }

  const isSwitchOnChange = async (newValue: { isValue: boolean; stateKey: string }) => {
    const isValueToInt = boolToInt(newValue.isValue)
    _onSubmit(isValueToInt, newValue.stateKey)
  }

  const boolToInt = (flag) => (flag ? 1 : 0)

  const autoBuy = () => {
    const s_auto_confirm_new_order_buy: boolean = selectedStore.get('s_auto_confirm_new_order_buy')
    let supTitleLable = p.op.t('StoreSetting.NoteFalseAutoConfirmPurchaseOrder')
    if (s_auto_confirm_new_order_buy) {
      supTitleLable = p.op.t('StoreSetting.NoteTrueAutoConfirmPurchaseOrder')
    }
    return (
      <HStack py='1.5'>
        <XSettingRow
          title={p.op.t('StoreSetting.MenuAutoConfirmPurchaseOrder')}
          supTitle={supTitleLable}
          value={s_auto_confirm_new_order_buy}
          onClick={(newValue: { isValue: boolean; stateKey: string }) => isSwitchOnChange(newValue)}
          stateKey='s_auto_confirm_new_order_buy'
        />
      </HStack>
    )
  }

  const autoSell = () => {
    const s_auto_confirm_new_order_sell: boolean = selectedStore.get('s_auto_confirm_new_order_sell')
    let supTitleLable = p.op.t('StoreSetting.NoteFalseAutoConfirmSalesOrder')
    if (s_auto_confirm_new_order_sell) {
      supTitleLable = p.op.t('StoreSetting.NoteTrueAutoConfirmSalesOrder')
    }
    return (
      <HStack py='1.5'>
        <XSettingRow
          title={p.op.t('StoreSetting.MenuAutoConfirmSalesOrder')}
          supTitle={supTitleLable}
          value={s_auto_confirm_new_order_sell}
          onClick={(newValue: { isValue: boolean; stateKey: string }) => isSwitchOnChange(newValue)}
          stateKey='s_auto_confirm_new_order_sell'
        />
      </HStack>
    )
  }

  // eslint-disable-next-line react/no-unstable-nested-components
  const _renderBody = () => (
    <XCard mx='2' mt='2' mb='2'>
      {autoBuy()}
      <Box _dark={{ borderBottomColor: 'white' }} _light={{ borderBottomColor: 'black' }} borderBottomWidth='1' />
      {autoSell()}
    </XCard>
  )

  return (
    <XContainer>
      {_renderHeader()}
      <XContent px='2' pb='2'>
        <Box w='full' mt='2' borderRadius='md' _light={{ bg: 'white' }} _dark={{ bg: NB.C.D.BG.CLEAR }}>
          {_renderBody()}
        </Box>
        {/* {isLoading ? VIEW_LOADING(windowWidth, windowHeight) : null} */}
      </XContent>
    </XContainer>
  )
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// // @ts-ignore
// StoreSettingOrderAutomation.navigationOptions = {
//   header: null,
// }

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
    editingStore: getEditingStore(state),
  }),
  (dispatch) => ({
    submitEditing: bindActionCreators(StoreActions.submitEditingStore, dispatch),
    resetEditingStore: bindActionCreators(StoreActions.resetEditingStore, dispatch),
    // storeActions: bindActionCreators(StoreState, dispatch),
  })
)(StoreSettingOrderAutomation)
